import { render, staticRenderFns } from "./aboutUsSlide.vue?vue&type=template&id=1f5825f8&scoped=true&"
import script from "./aboutUsSlide.vue?vue&type=script&lang=js&"
export * from "./aboutUsSlide.vue?vue&type=script&lang=js&"
import style0 from "./aboutUsSlide.vue?vue&type=style&index=0&id=1f5825f8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5825f8",
  null
  
)

export default component.exports